import self from "../img/self.png"
import mock1 from "../img/mock1.png"
import mock2 from "../img/mock2.png"
import mock3 from "../img/mock3.png"
import mock4 from "../img/mock4.png"
import mock5 from "../img/mock5.png"
import chavego1 from "../img/chavego1.png"
import chavego2 from "../img/chavego2.png"
import ulen1 from "../img/ulen1.png"
import ulen2 from "../img/ulen2.png"
import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
export let singlePage = false;

const commonInfo = {
    firstName: "Helber",
    lastName: "Spencer",
    initials: "hs",
    resume: "/cv.pdf",
    selfPortrait: self,
    gradient: `-webkit-linear-gradient(135deg, ${colors})`,
    baseColor: colors[0],
    socials: [
        {
            link: "https://www.facebook.com/Helber11",
            icon: 'fa-brands fa-facebook',
            label: 'facebook'
        },
        {
            link: "https://www.instagram.com/helber.11/",
            icon: 'fa-brands fa-instagram',
            label: 'instagram'
        },
        {
            link: "https://github.com/Devh-cv",
            icon: "fa-brands fa-github",
            label: 'github'
        },
        {
            link: "https://br.fiverr.com/s/R7g2lP8",
            icon: "fa-brands fa-fiverr",
            label: 'fiverr'
        }
    ],
};

export const infoEn = {
    ...commonInfo,
    position: "build premium web & mobile apps",
    miniBio: [
        { emoji: '🚀', text: 'Building products with clean code & AI' },
        { emoji: '🇨🇻', text: 'From Cape Verde, based in Portugal' },
        { emoji: "💼", text: "Mobile App Developer & AI Enthusiast" },
        { emoji: "📧", text: "helber@dudedev.com" }
    ],
    bio: "I’m Helber, a Cape Verdean Full Stack Developer based in Portugal. I create modern websites, mobile apps, and digital platforms with clean design, strong functionality, and a premium user experience. My focus is building products that solve real problems and help businesses grow online. I work with Flutter, Laravel, Next.js, PHP, JavaScript, and AI integrations (OpenAI/Claude), creating smart solutions for marketplaces, booking systems, SaaS platforms, and mobile apps.",
    skills: {
        "App & Web": ['Flutter', 'React / Next.js', 'JavaScript / TS', 'Tailwind CSS'],
        "Backend": ['Laravel / PHP', 'Firebase', 'MySQL', 'REST APIs'],
        "AI & Automation": ['OpenAI API', 'Claude API', 'GitHub Copilot', 'Prompt Engineering'],
        "UI/UX & Tools": ['Figma', 'Design Systems', 'Git / GitHub']
    },
    hobbies: [
        { label: 'Building digital products', emoji: '💻' },
        { label: 'Mobile app design', emoji: '📱' },
        { label: 'Entrepreneurship', emoji: '🚀' },
        { label: 'Football', emoji: '⚽' },
        { label: 'Travel & culture', emoji: '🌍' },
        { label: 'Learning new technologies', emoji: '🛠️' }
    ],
    portfolio: [
        {
            title: "ChaveGo — Car Rental Platform",
            description: "A modern car rental platform with web and mobile experiences for booking vehicles, managing rentals, and connecting customers with car owners.",
            tags: ["Web App", "Mobile App", "UI/UX", "Booking System"],
            featured: true,
            links: [
                { type: 'primary', link: "https://chavego.dudedev.com/", title: "Open Web App", icon: "fa-solid fa-globe" },
                { type: 'secondary', link: "https://play.google.com/store/apps/details?id=com.dollarvan.user&hl=pt_PT", title: "Google Play", icon: "fa-brands fa-google-play" },
                { type: 'secondary', link: "https://apps.apple.com/us/app/chavego/id6775959505", title: "App Store", icon: "fa-brands fa-apple" }
            ],
            image: [chavego2, chavego1]
        },
        {
            title: "Ulen — Super App Platform",
            description: "A multi-service platform for ride-hailing, delivery, rentals, bookings, and local services — designed to help businesses launch an all-in-one digital ecosystem.",
            tags: ["Super App", "Ride & Delivery", "Marketplace", "Mobile App", "Admin Panel"],
            featured: true,
            links: [
                { type: 'primary', link: "https://ulen.com.br/", title: "Open Web App", icon: "fa-solid fa-globe" },
                { type: 'secondary', link: "https://play.google.com/store/apps/details?id=com.ulen.user&hl=pt_BR", title: "Google Play", icon: "fa-brands fa-google-play" },
                { type: 'secondary', link: "https://apps.apple.com/br/app/ulen-viajar-%C3%A9-econ%C3%B4mico/id1643311880", title: "App Store", icon: "fa-brands fa-apple" }
            ],
            image: [ulen1, ulen2]
        }
    ]
};

export const infoPt = {
    ...commonInfo,
    position: "crio apps mobile & web premium",
    miniBio: [
        { emoji: '🚀', text: 'Criando produtos com código limpo & IA' },
        { emoji: '🇨🇻', text: 'Cabo-verdiano, a residir em Portugal' },
        { emoji: "💼", text: "Desenvolvedor Mobile & Entusiasta IA" },
        { emoji: "📧", text: "helber@dudedev.com" }
    ],
    bio: "Sou o Helber, um Full Stack Developer cabo-verdiano a residir em Portugal. Crio websites modernos, apps mobile e plataformas digitais com design limpo, forte funcionalidade e uma experiência de utilizador premium. O meu foco é construir produtos que resolvem problemas reais e ajudam negócios a crescer online. Trabalho com Flutter, Laravel, Next.js, PHP, JavaScript e integrações com Inteligência Artificial (OpenAI/Claude), criando soluções inteligentes para marketplaces, sistemas de reservas, plataformas SaaS e apps mobile.",
    skills: {
        "App & Web": ['Flutter', 'React / Next.js', 'JavaScript / TS', 'Tailwind CSS'],
        "Backend": ['Laravel / PHP', 'Firebase', 'MySQL', 'REST APIs'],
        "AI & Automação": ['OpenAI API', 'Claude API', 'GitHub Copilot', 'Prompt Engineering'],
        "UI/UX & Ferramentas": ['Figma', 'Design Systems', 'Git / GitHub']
    },
    hobbies: [
        { label: 'Criar produtos digitais', emoji: '💻' },
        { label: 'Design de apps mobile', emoji: '📱' },
        { label: 'Empreendedorismo', emoji: '🚀' },
        { label: 'Futebol', emoji: '⚽' },
        { label: 'Viagens & Cultura', emoji: '🌍' },
        { label: 'Aprender novas tecnologias', emoji: '🛠️' }
    ],
    portfolio: [
        {
            title: "ChaveGo — Plataforma de Aluguer de Carros",
            description: "Uma plataforma moderna de aluguer de carros com experiências web e mobile para reservas, gestão de alugueres e conexão entre clientes e proprietários de veículos.",
            tags: ["Web App", "Mobile App", "UI/UX", "Sistema de Reservas"],
            featured: true,
            links: [
                { type: 'primary', link: "https://chavego.dudedev.com/", title: "Abrir Web App", icon: "fa-solid fa-globe" },
                { type: 'secondary', link: "https://play.google.com/store/apps/details?id=com.dollarvan.user&hl=pt_PT", title: "Google Play", icon: "fa-brands fa-google-play" },
                { type: 'secondary', link: "https://apps.apple.com/us/app/chavego/id6775959505", title: "App Store", icon: "fa-brands fa-apple" }
            ],
            image: [chavego2, chavego1]
        },
        {
            title: "Ulen — Plataforma Super App",
            description: "Uma plataforma multi-serviços de mobilidade (ride-hailing), entregas, alugueres e serviços locais — concebida para ajudar empresas a lançar um ecossistema digital completo.",
            tags: ["Super App", "Mobilidade & Entregas", "Marketplace", "Mobile App", "Painel Admin"],
            featured: true,
            links: [
                { type: 'primary', link: "https://ulen.com.br/", title: "Abrir Web App", icon: "fa-solid fa-globe" },
                { type: 'secondary', link: "https://play.google.com/store/apps/details?id=com.ulen.user&hl=pt_BR", title: "Google Play", icon: "fa-brands fa-google-play" },
                { type: 'secondary', link: "https://apps.apple.com/br/app/ulen-viajar-%C3%A9-econ%C3%B4mico/id1643311880", title: "App Store", icon: "fa-brands fa-apple" }
            ],
            image: [ulen1, ulen2]
        }
    ]
};

// Fallback for backwards compatibility in case any component imports 'info' directly temporarily
export const info = infoEn;

export const useInfo = () => {
    const { language } = useContext(LanguageContext);
    return language === 'pt' ? infoPt : infoEn;
};